export const VERSION_APP = "0.14.2-alpha"
export const VERSION_API = 3 // refers to redux-persist version
export const VERSION_SCORE = "1.0.0-beta" // refers to redux-persist version
